import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import EmployeeOptionalForm from '@/components/employee-optionals/EmployeeOptionalForm.vue';
    import { EmployeeOptional } from '@/types';
    import QueryKey from '@/enums/QueryKey';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditEmployeeOptional',
  props: {
    employeeOptional: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const { id, name, ...fillable } = props.employeeOptional;

    const form = useForm({
        ...fillable,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    method: "post",
    form: _unref(form),
    route: _ctx.route('v2.salary.employees-optionals.update', { companyId: _ctx.employeeOptional.id }),
    "query-key": [_unref(QueryKey).EMPLOYEE_OPTIONALS],
    title: "employees-optionals.page_header",
    "submit-text": "forms.save",
    "hide-success-toast": "",
    onSuccess: _cache[0] || (_cache[0] = 
            () => {
                _unref(toast).success(_unref(t)('forms.general.success'), {
                    description: _unref(t)('employees-optionals.success', {
                        company_name: _ctx.employeeOptional.name,
                    }),
                });
            }
        )
  }, {
    default: _withCtx(() => [
      _createVNode(EmployeeOptionalForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})